import React from 'react';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { getLocale } from '@raisin/cp-utils';
import { RaisinUIProviderProps } from '@raisin/components-lib/*';
import { getRaisinAppProps, Layout } from '@raisin/cp-layout';
import { layoutData } from '__mocks__/layoutdata';
import {
  canonicalLink,
  CountrySelector,
  metaDescription,
  metaTitle,
} from 'components/CountrySelector';
import { useTranslationProvider } from 'hooks/useTranslationProvider';

const CountrySelectorPage = ({
  themeVersion,
}: {
  themeVersion: RaisinUIProviderProps['version'] | undefined;
}) => {
  const router = useRouter();
  const locale = getLocale(router.locale)?.intlFormat;
  useTranslationProvider({ locale });

  return (
    <Layout
      layout={layoutData}
      pageTitle={metaTitle}
      tagline={false}
      isCountrySelectorPage
      themeVersion={themeVersion}
    >
      <Head>
        <meta name="description" content={metaDescription} />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={canonicalLink} />
      </Head>
      <CountrySelector />
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const props = await getRaisinAppProps({ locale: 'en', isLayoutNeeded: false });
  return {
    props,
    revalidate: 60,
  };
};

export default CountrySelectorPage;
